import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Loading } from '../../loading'
import { selectIsSave } from '../store/slice'
import { getFilterDefault } from '../store/thunk'
import { useCallApi } from '../useCallApi'
import { GroupBtnAction } from './components/GroupBtnAction'
import classes from './index.module.scss'
import { Detail } from './panel/Detail'
import { Header } from './panel/Header'
import { Summary } from './panel/Summary'

export const FilterCompanySetting = ({
  filterType,
  buttonBackProps,
  onSave,
  onSaveDefault,
}) => {
  const dispatch = useDispatch()

  const { isLoading, isLoadingPort } = useCallApi()
  const isSaveOnly = useSelector(selectIsSave)

  useEffect(() => {
    if (!isSaveOnly && !isLoadingPort) {
      dispatch(getFilterDefault({ FilterType: filterType }))
    }
  }, [isSaveOnly, isLoadingPort])

  if (isLoading) return <Loading />

  return (
    <div className={classes.filterSetting}>
      <Header buttonBackProps={buttonBackProps} />
      <Summary />
      <div className={classes.detailPanel}>
        <Detail />
      </div>
      <div className={classes.groupBtn}>
        <GroupBtnAction
          filterType={filterType}
          onSave={onSave}
          onSaveDefault={onSaveDefault}
        />
      </div>
    </div>
  )
}

FilterCompanySetting.propTypes = {
  filterType: PropTypes.string,
}

FilterCompanySetting.defaultProps = {
  filterType: 'Library', //FILTER_TYPE.LIBRARY
}
